import { Activity, QCActivity } from './types'
const MAX_SLICE_ITEMS = 10

export const sliceData = (
  list: Activity[] | QCActivity[]
): Activity[] | QCActivity[] => {
  return list.slice(0, MAX_SLICE_ITEMS)
}
